import React, { CSSProperties, FC, useContext } from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import clsx from 'clsx'

import Input from '../../../../common/inputs/Input'
import MessageHelperComp from '../../../../../helpers/MessageHelper'

import {
  IScoreCardInterface,
  IScoreCardRow,
} from '../../../../../models/score-cards/score-cards.interface'

import { MODAL_CONSTS } from '../../../../../const/modal-const'
import { HandleModalContext } from '../../../../../layout/mainlayout/MainLayout'

interface ScoreCardRowProps {
  index: number
  rowIndex: number
  row: IScoreCardRow
  register: UseFormRegister<IScoreCardInterface>
  watch: UseFormWatch<IScoreCardInterface>
  errors: FieldErrors<IScoreCardInterface>
  setValue: UseFormSetValue<IScoreCardInterface>
  editable?: boolean
}

export const ScoreCardRow: FC<ScoreCardRowProps> = ({
  index,
  rowIndex,
  row,
  register,
  watch,
  errors,
  setValue,
  editable,
}) => {
  const handleModalContext = useContext(HandleModalContext)
  const handleModal = handleModalContext?.handleModal

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: row.id,
  })

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: transition,
  }

  const onRemoveRow = () => {
    handleModal?.(true, MODAL_CONSTS.REMOVE_CONFIRMATION, {
      ...handleModalContext?.dataToPassOn,
      removeItem: () => {
        setValue(
          `sections.${index}.rows`,
          watch(`sections.${index}.rows`)?.filter((field) => field.id !== row.id)
        )
      },
    })
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={clsx(
        'mt-2 w-full relative border  rounded-lg flex flex-wrap items-center justify-between p-3.5 md:pl-10',
        !!watch(`sections.${index}.rows.${rowIndex}.description`)
          ? 'bg-SeabiscuitGrayThemeColor border-transparent'
          : 'border-SeabiscuitLightThemeColorD3'
      )}
    >
      <div
        {...attributes}
        {...listeners}
        className="drag-handle hidden md:flex cursor-pointer opacity-50 hover:opacity-100 w-11 h-full absolute left-0 p-3 top-0 transition-all"
      >
        <img src="/assets/cp_icons/Move.svg" alt="moveIcon" className="w-full" />
      </div>
      <div className="relative w-full">
        <Input
          disabled={!editable}
          className="p-0 pr-6 border-none bg-transparent"
          register={register}
          placeholder="Jump..."
          name={`sections.${index}.rows.${rowIndex}.description`}
          value={watch(`sections.${index}.rows.${rowIndex}.description`)}
        />
        {!!errors?.sections?.[index]?.rows?.[rowIndex]?.description?.message ? (
          <MessageHelperComp
            className="absolute z-0 bottom-1 left-0 translate-y-full"
            isError={true}
            message={errors?.sections?.[index]?.rows?.[rowIndex]?.description?.message}
          />
        ) : null}
      </div>
      <button
        disabled={!editable}
        className="cursor-pointer absolute top-1/2 -translate-y-1/2 flex items-center w-6 right-2 hover:opacity-70 transition-all"
        onClick={onRemoveRow}
      >
        <img className="w-full" src="/assets/og_icons/Cancel.svg" alt="" />
      </button>
    </div>
  )
}
